import script from "./Account.vue?vue&type=script&setup=true&lang=js"
export * from "./Account.vue?vue&type=script&setup=true&lang=js"

import "./Account.vue?vue&type=style&index=0&id=553225cc&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-553225cc"]])

export default __exports__